export default "__VITE_ASSET__Uy$qym1V__"